import { SVGPropsIcon } from 'src/types';

export const EnLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={`w-[25px] h-[25px] ${props.className}`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4_7321)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path
          d="M2.48032 4.69409C1.53771 5.92048 0.826945 7.334 0.413086 8.86958H6.6558L2.48032 4.69409Z"
          fill="#0052B4"
        />
        <path
          d="M23.5864 8.86953C23.1725 7.334 22.4617 5.92048 21.5191 4.69409L17.3438 8.86953H23.5864Z"
          fill="#0052B4"
        />
        <path
          d="M0.413086 15.1304C0.826992 16.6659 1.53776 18.0794 2.48032 19.3058L6.65566 15.1304H0.413086Z"
          fill="#0052B4"
        />
        <path
          d="M19.3053 2.48061C18.0789 1.538 16.6655 0.827236 15.1299 0.41333V6.656L19.3053 2.48061Z"
          fill="#0052B4"
        />
        <path
          d="M4.69434 21.5193C5.92073 22.4619 7.33424 23.1727 8.86977 23.5866V17.344L4.69434 21.5193Z"
          fill="#0052B4"
        />
        <path
          d="M8.86973 0.41333C7.3342 0.827236 5.92068 1.538 4.69434 2.48056L8.86973 6.65595V0.41333Z"
          fill="#0052B4"
        />
        <path
          d="M15.1299 23.5866C16.6654 23.1727 18.0789 22.4619 19.3053 21.5194L15.1299 17.344V23.5866Z"
          fill="#0052B4"
        />
        <path
          d="M17.3438 15.1304L21.5191 19.3058C22.4617 18.0795 23.1725 16.6659 23.5864 15.1304H17.3438Z"
          fill="#0052B4"
        />
        <path
          d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
          fill="#D80027"
        />
        <path
          d="M15.1309 15.1304L20.4857 20.4852C20.732 20.239 20.9669 19.9817 21.191 19.7148L16.6066 15.1304H15.1309V15.1304Z"
          fill="#D80027"
        />
        <path
          d="M8.86951 15.1306H8.86941L3.51465 20.4854C3.76084 20.7317 4.01823 20.9666 4.28504 21.1908L8.86951 16.6062V15.1306Z"
          fill="#D80027"
        />
        <path
          d="M8.86976 8.8696V8.86951L3.51495 3.51465C3.26866 3.76084 3.03373 4.01823 2.80957 4.28504L7.39409 8.86955H8.86976V8.8696Z"
          fill="#D80027"
        />
        <path
          d="M15.1309 8.86956L20.4857 3.51465C20.2395 3.26837 19.9821 3.03344 19.7153 2.80933L15.1309 7.39384V8.86956Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7321">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7162)">
        <path
          d="M0.746094 16.1738C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738L11.9997 15.1304L0.746094 16.1738Z"
          fill="#FFDA44"
        />
        <path
          d="M11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611L11.9997 8.86955L23.2533 7.82606C21.5578 3.2565 17.1593 0 11.9997 0Z"
          fill="black"
        />
        <path
          d="M0.746391 7.82617C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617H0.746391Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_7162">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_4_7258)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F0F0F0"
        />
        <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12" fill="#D80027" />
      </g>
      <defs>
        <clipPath id="clip0_4_7258">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RoLang = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g clipPath="url(#clip0_18664_110295)">
        <path
          d="M13.2812 0.674316V19.3035C17.1156 17.9479 19.8639 14.2943 19.8672 9.99627V9.98134C19.8639 5.68358 17.1156 2.0297 13.2812 0.674316Z"
          fill="#DE2110"
        />
        <path
          d="M6.69531 19.3033V0.674316C2.85878 2.0308 0.109375 5.68775 0.109375 9.98881C0.109375 14.2899 2.85878 17.9468 6.69531 19.3033Z"
          fill="#00319C"
        />
        <path
          d="M6.69531 19.3033C7.75287 19.6774 8.86651 19.8682 9.98828 19.8677C11.1432 19.8677 12.251 19.6677 13.2812 19.3033V0.67406C12.2237 0.300042 11.11 0.109239 9.98828 0.109865C8.86651 0.109296 7.75287 0.300175 6.69531 0.67428V19.3033Z"
          fill="#FFDE00"
        />
      </g>
      <defs>
        <clipPath id="clip0_18664_110295">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
